import type { NodeTypeCategory } from './workflowDefinition'

export const ParameterTypes = {
  String: 'string',
  Integer: 'integer',
  Boolean: 'boolean',
  Secret: 'secret',
  Text: 'text',
  Textarea: 'textarea',
  Select: 'select',
} as const

export type ParameterType = typeof ParameterTypes[keyof typeof ParameterTypes]

export interface WorkflowTaskParameterSchema {
  name: string
  displayName?: string
  type: ParameterType
  required: boolean
  description: string
  defaultValue?: string | number | boolean
  options?: string[]
}

export interface ChatCommandDescriptor {
  name: string
  displayName: string
  description: string
  category: NodeTypeCategory
  icon: string
  parameters: WorkflowTaskParameterSchema[]
}

export interface ExecuteChatCommandRequest {
  chatId: string
  commandName: string
  params: Record<string, string>
}

export interface ChatCommandResult {
  success: boolean
  outputs: Record<string, string>
  errorMessage: string | null
  durationMs: number
}

export const WorkflowRunStatuses = {
  Pending: 'Pending',
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  AwaitingApproval: 'AwaitingApproval',
} as const

export type WorkflowRunStatus = typeof WorkflowRunStatuses[keyof typeof WorkflowRunStatuses]

export const WorkflowPhaseStatuses = {
  Pending: 'Pending',
  Running: 'Running',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  Skipped: 'Skipped',
  AwaitingApproval: 'AwaitingApproval',
  AwaitingUserInput: 'AwaitingUserInput',
} as const

export type WorkflowPhaseStatus = typeof WorkflowPhaseStatuses[keyof typeof WorkflowPhaseStatuses]

export interface WorkflowRunPhaseInfo {
  name: string
  order: number
  status: WorkflowPhaseStatus
}

export interface WorkflowRunSummary {
  id: string
  definitionId: string
  definitionName: string
  definitionDisplayName: string
  definitionVersion: number
  status: WorkflowRunStatus
  triggeredBy: string
  triggeredFrom: 'UI' | 'Chat' | 'API'
  projectId: string
  createdAt: string
  startedAt: string | null
  completedAt: string | null
  totalPhases: number
  completedPhases: number
  currentPhaseName: string | null
  errorSummary: string | null
  phases: WorkflowRunPhaseInfo[]
}
